// extracted by css-extract-rspack-plugin
export default {"header":"wAt4yMxJgRUTqna7","subheader":"hfVTtJ9mfaIrmxZG","content":"SwdDQxzy0rEfW5kP","nav":"EG0qoY_kQWTNytM7","sidebar":"Xtmk0UMKMTU7pY2N"};